export const ROUTES = {
  DASHBOARD: "/dashboard",
  PAYOUTS: "/payouts",
  CONTRACTORS: "/contractors",
  CONTRACTOR_DETAIL: "/contractors/:uuid",
  CLIENTS: "/clients",
  CLIENT_DETAIL: "/clients/:uuid",
  PUSH_CAMPAIGNS: "/push-campaigns",
  PUSH_CAMPAIGN_NEW: "/push-campaigns/new",
  PUSH_CAMPAIGN_EDIT: "/push-campaigns/:uuid/edit",
  PUSH_CAMPAIGN_DETAIL: "/push-campaigns/:uuid",
  FEEDBACK: "/feedback",
  FEEDBACK_SETTINGS: "/feedback/settings",
  GAS_STATIONS: "/gas-stations",
  HELP: "/help",
  HELP_SETTINGS: "/help/settings",
  AUTH_PHONE: "/auth/phone",
  AUTH_CODE: "/auth/code",
  NOT_FOUND: "/404",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];
